<template lang="pug">
#bloco-resumo-contrato-originacao
    el-card(shadow='never', :body-style='{ padding: "0px" }')
        .bloco-resumo-contrato-originacao__coluna-esquerda
            .bloco-resumo-contrato-originacao__cabecalho
                p Resumo
                p Total

            .bloco-resumo-contrato-originacao__linha
                p Volume contratado (t)
                p {{ resumo.volumeContratado }}

            .bloco-resumo-contrato-originacao__linha
                p Volume inserido (t)
                p {{ resumo.volumeInserido }}

            .bloco-resumo-contrato-originacao__linha
                p Volume com restricao (t)
                p(:class='resumo.volumeComRestricoes > 0 ? "vermelho" : ""') {{ resumo.volumeComRestricoes }}

            .bloco-resumo-contrato-originacao__linha
                p Saldo
                p {{ resumo.saldo }}

        .bloco-resumo-contrato-originacao__coluna-direita
            .bloco-resumo-contrato-originacao__cabecalho
                p Resumo
                p Total

            .bloco-resumo-contrato-originacao__linha
                p Número territórios inseridos
                p {{ resumo.territoriosInseridos }}

            .bloco-resumo-contrato-originacao__linha
                p
                    i.flow.flow-verified.verde.mr-2
                    | Número de territórios conformes
                p {{ resumo.territoriosConformes }}

            .bloco-resumo-contrato-originacao__linha
                p
                    i.flow.flow-warning-sign.vermelho.mr-2
                    | Número de territórios inconformes
                p {{ resumo.territoriosInConformes }}
</template>

<script>
export default {
    name: 'BlocoResumoContratoOriginacao',

    props: {
        resumo: {
            required: true,
            type: Object
        }
    },

    data() {
        return {};
    },

    methods: {}
};
</script>

<style lang="scss">
#bloco-resumo-contrato-originacao {
    .bloco-resumo-contrato-originacao__linha,
    .bloco-resumo-contrato-originacao__cabecalho {
        display: flex;
        justify-content: space-between;
        padding: 8px 16px;

        p {
            margin-bottom: 0px;
        }
    }

    .bloco-resumo-contrato-originacao__coluna-esquerda,
    .bloco-resumo-contrato-originacao__coluna-direita {
        width: 50%;
    }

    .bloco-resumo-contrato-originacao__coluna-esquerda {
        border-right: 1px solid var(--gray);
    }

    .bloco-resumo-contrato-originacao__cabecalho {
        font-weight: bold;
        border-bottom: 1px solid var(--gray);
    }

    .bloco-resumo-contrato-originacao__linha:nth-child(odd) {
        background-color: var(--list-background-contrast);
    }

    .el-card__body {
        display: flex;
    }
}
</style>
